module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"งานซ่อมที่เสร็จสิ้น","page.description":"รายการของ ใบงานที่ได้ดำเนินการเสร็จสิ้นแล้ว"}}')
  delete Component.options._Ctor
}
